const parseFooterInfo = (item) => {
  // Ad ottobre 2024, sembra che abbiano dei dati puliti in cui href sono con l'url gia' corretto,
  // potenzialmente eliminabile per intero questa funzione, tenuta per storico.
  // Se metton cose nuove a mano e non va, sarei per dire "scrivete le cose a modino dal configuratore"

  return item.text?.data;
};

export const parseFooterItemsUrl = (item) => {
  const isSearchSite =
    (__CLIENT__ && !!window.env.RAZZLE_SOLR_SEARCH_SITE) ||
    !!process.env.RAZZLE_SOLR_SEARCH_SITE ||
    false;
  if (!isSearchSite) return item;
  if (!item) return {};

  let parsedItem = { ...item };
  if (item.url?.includes('/api')) {
    parsedItem = {
      ...parsedItem,
      url: item.url.replace('/api', ''),
    };
  }
  if (item.items?.some((i) => i?.url?.includes('/api'))) {
    parsedItem = {
      ...parsedItem,
      items: parsedItem.items.map((pi) => ({
        ...pi,
        url: pi.url.replace('/api', ''),
      })),
    };
  }
  if (item.hasOwnProperty('linkUrl')) {
    parsedItem = {
      ...parsedItem,
      linkUrl: item.linkUrl?.map((lu) => ({
        ...lu,
        '@id': lu?.['@id']?.replace('/api', ''),
      })),
    };
  }
  if (item.hasOwnProperty('text')) {
    parsedItem = {
      ...parsedItem,
      text: {
        data: parseFooterInfo(item),
      },
    };
  }
  if (item.hasOwnProperty('titleLink')) {
    parsedItem = {
      ...parsedItem,
      titleLink: item.titleLink?.map((tl) => ({
        ...tl,
        '@id': `${
          (__CLIENT__ && !!window.env.RAZZLE_MAIN_SITE_URL
            ? window.env.RAZZLE_MAIN_SITE_URL
            : '') || process.env.RAZZLE_MAIN_SITE_URL
        }${tl?.['@id']}`,
      })),
    };
  }
  return parsedItem;
};
